import React, { FunctionComponent } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Currency } from "@Types/api/price";
import freeShipping from "./images/free-shipping.gif";
import "./style.scss";

interface Props {
  currency: Currency;
}

const CartFreeShipping: FunctionComponent<Props> = ({ currency }) => {
  const intl = useIntl();

  const freeShippingAmount = intl.formatNumber(50, {
    currency,
    minimumFractionDigits: 0,
    style: "currency",
  });

  return (
    <div className="CartFreeShipping">
      <div className="CartFreeShipping-logo-wrapper">
        <img className="CartFreeShipping-logo" src={freeShipping} />
      </div>
      <div className="CartFreeShipping-text">
        <div>
          <FormattedMessage
            id="cheerz_CartFreeShipping_label"
            values={{
              amount: freeShippingAmount,
              span: (...chunks: string[]) => <span>{chunks}</span>,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CartFreeShipping;
